/**
 * Выбор темы человека.
 *
 * Тёмная — по умолчанию (решение владельца от 19.10.2026, как в «Астре» с 10.10),
 * светлая — только ручным выбором.
 * Тема хоста (Telegram/VK/система) сюда не попадает намеренно: тема,
 * выбранная за человека, расходилась бы со снимками в каталогах (6.3).
 *
 * Хранится на устройстве: это оформление, а не данные аккаунта. Любой сбой
 * хранилища — не ошибка для человека: тема работает в пределах сессии.
 */

export type ThemeChoice = 'light' | 'dark';

/** Тот же ключ читает public/theme-init.js — менять только вместе. */
export const THEME_STORAGE_KEY = 'astra-theme';

/** Фон темы (--astra-bg в src/index.css) — для хрома хоста и браузерной полосы. */
export const CHROME_BACKGROUND: Record<ThemeChoice, string> = {
  light: '#F7F5EF',
  dark: '#1B1F3B',
};

export interface ChromeTarget {
  setChrome(chrome: { background: string; scheme: ThemeChoice }): void;
}

export function readThemeChoice(): ThemeChoice {
  try {
    return window.localStorage.getItem(THEME_STORAGE_KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function writeThemeChoice(choice: ThemeChoice): void {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, choice);
  } catch {
    // Хранилище недоступно — выбор проживёт до закрытия приложения.
  }
}

export function applyTheme(choice: ThemeChoice, chrome?: ChromeTarget): void {
  const root = document.documentElement;

  if (choice === 'dark') {
    root.setAttribute('data-theme', 'dark');
  } else {
    root.removeAttribute('data-theme');
  }

  const background = CHROME_BACKGROUND[choice];
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', background);
  chrome?.setChrome({ background, scheme: choice });
}
